import { forwardRef } from 'react';
import { userSelector } from '@lingoda/auth';
import { useSelector } from '@lingoda/hooks';
import { BaseAppBar } from '../components/BaseAppBar';
import { LoggedUserHeader } from './LoggedUserHeader';
import { SimpleHeader } from './SimpleHeader';
import { UnknownUserHeader } from './UnknownUserHeader';

export interface Props {
    logoIsIcon?: boolean;
    hideNavigation?: boolean;
    disabledLogo?: boolean;
    unClickable?: boolean;
    elevation?: number;
}

export const PublicHeader = forwardRef<HTMLDivElement, Props>(
    ({ elevation = 0, hideNavigation, disabledLogo, unClickable, logoIsIcon }, ref) => {
        const user = useSelector(userSelector);

        return (
            <BaseAppBar elevation={elevation} ref={ref}>
                {hideNavigation ? (
                    <SimpleHeader
                        logoIsIcon={logoIsIcon}
                        disabledLogo={disabledLogo}
                        unClickable={unClickable}
                    />
                ) : user ? (
                    <LoggedUserHeader disabledLogo={disabledLogo} />
                ) : (
                    <UnknownUserHeader disabledLogo={disabledLogo} />
                )}
            </BaseAppBar>
        );
    },
);

PublicHeader.displayName = 'PublicHeader';
